import { FC } from "react";
import { NotificationDTO } from "../../../../domain/models/dto/NotificationDTO";
import CreateCommentIconSVG from "../../../resources/svg/CreateCommentIconSVG";
import { useTranslation } from "react-i18next";
import useScreenSize from "../../../../custom-hooks/base-hooks/useScreenSize";
import { getNotificationCreatedTime } from "../../../../slices/notifications-slice";
import CreateReviewPopup from "../../../resources/components/review-components/CreateReviewPopup";
import useCurrentReview from "../../../../custom-hooks/domain/useCurrentReview";
import { getUserFirstName } from "../../../../slices/user-slice";

interface ReviewCreateCardProps {
    notification: NotificationDTO;
}

const ReviewCreateCard: FC<ReviewCreateCardProps> = (props) => {
    const { t } = useTranslation();
    const { upTo800, moreOrEqual800 } = useScreenSize();
    const { isModalVisible, setModalVisible, subject, currentReview } = useCurrentReview(props.notification);

    return (
        <>
            <div
                onClick={() => setModalVisible(true)}
                className="flex w-full bg-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.16)] rounded-[10px] py-9 dmax2:py-5 px-10 dmax2:px-4 cursor-pointer transition duration-300"
            >
                <CreateCommentIconSVG className="min-w-8 dmax2:min-w-6 min-h-8 dmax2:min-h-6 text-textFaded mr-6 dmax2:mr-3" />
                <div className="flex flex-col w-full">
                    <div className="flex justify-between">
                        <span className="H24B dmax2:H16B text-textWhite text-left max-w-[550px] line-clamp-2">
                            {currentReview
                                ? t("reviews.successMessage")
                                : t(`notifications.${props.notification.type}`) + " " + getUserFirstName(subject)}
                        </span>
                        {moreOrEqual800 && (
                            <span className="H16 dmax2:H14 text-textFaded">
                                {getNotificationCreatedTime(t, props.notification, true)}
                            </span>
                        )}
                    </div>
                    <span className="H20B dmax2:H14B text-textWarning text-left mt-4 dmax2:mt-2 [word-break:break-word]">
                        {props.notification.application.work.title}
                    </span>
                    {upTo800 && (
                        <span className="H16 dmax2:H14 text-textFaded text-end mt-2">
                            {getNotificationCreatedTime(t, props.notification, true)}
                        </span>
                    )}
                </div>
            </div>
            <CreateReviewPopup
                isVisible={isModalVisible}
                setVisible={setModalVisible}
                notification={props.notification}
            />
        </>
    );
};

export default ReviewCreateCard;
